import { useEffect, useState } from 'react';

export default function Hero() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <section className="relative h-screen flex items-center justify-center">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/cd0b8fbadfd9bb3ab0eb8c9f05946b2e.jpg"
          alt="住宅の打ち合わせで悩んでいる様子"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/25 to-black/20"></div>
      </div>

      <div className="relative z-10 max-w-[1100px] mx-auto px-6 w-full flex flex-col items-center justify-center">
        <h1 
          className={`text-3xl md:text-5xl font-bold text-[#5A4033] text-center leading-relaxed transition-opacity duration-[2000ms] ease-out ${
            isVisible ? 'opacity-100' : 'opacity-0'
          }`}
          style={{
            WebkitTextStroke: '4px #FFFFFF',
            paintOrder: 'stroke fill',
            textShadow: '0 0 8px rgba(255,255,255,0.8)'
          }}
        >
          <span className="md:hidden block">
            家づくりの<br />
            「わからない」を<br />
            解決<br />
            プロと始める<br />
            安心の第一歩
          </span>
          <span className="hidden md:block">
            家づくりの「わからない」を解決。<br />
            プロと始める安心の第一歩。
          </span>
        </h1>

        {/* スマホ版CTA */}
        <div className="md:hidden mt-12">
          <button
            onClick={() => window.open('https://lin.ee/luTEHR8', '_blank')}
            className="bg-[#F2A67E] text-white px-8 py-4 rounded-xl text-base font-bold hover:opacity-90 transition-opacity cursor-pointer whitespace-nowrap shadow-lg flex items-center gap-2"
          >
            <i className="ri-line-fill text-2xl"></i>
            LINEで相談してみる
          </button>
        </div>
      </div>
    </section>
  );
}